import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import Drag from '@/components/common/Drag.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsibleWidget',
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    canDrag: {
      type: Boolean,
      default: false,
    },
    initialOpenState: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['delete'],
  setup(__props) {

const props = __props;

  
  

  const state = ref(props.initialOpenState)
  const delayOpen = ref(props.initialOpenState)
  const { trashIcon, closedCategory, openCategory } = useIcons()

  const onHeaderClick = () => {
    state.value = !state.value
    delayOpen.value = true
    setTimeout(() => {
      delayOpen.value = false
    }, 600)
    setTimeout(() => {
      eventBus.$emit('reset-background-tile-height')
    }, 300)
  }

return { __sfc: true,props, state, delayOpen, trashIcon, closedCategory, openCategory, onHeaderClick, ref, SVGRenderer, useIcons, Drag, HTMLRenderer, eventBus }
}

})